export default __webpack_public_path__ + "static/media/top-bg-modal.9be30631.png";